import { ILandingProcessedPlanningFetched } from 'partner360/models/landing/ILandingProcessedPlanningFetched'

export const getCount = (data: ILandingProcessedPlanningFetched[]) => {
  return Array.from(new Set(data.map((item) => `${item.offering}-${item.partnerId}`))).length
}
